import { FC } from 'react';
import { Button, Col, Input, Row } from 'antd';
import { TbSearch, TbX } from 'react-icons/tb';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { FlexContentRegion, FullHeightFlexColumn } from '@/shared';
import { SetStateMethod } from '@/types';

import DataSourceList from './components/DataSourceList';

interface ContentProps {
    view: 'add' | 'manage';
    setOpen: SetStateMethod<boolean>;
    input: string;
    setInput: SetStateMethod<string>;
    option: string;
    options: any[];
    loading?: boolean;
}

const Content: FC<ContentProps> = ({ view, option, options, setOpen, input, setInput, loading }): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <FullHeightFlexColumn>
            <Row align='middle' style={{ marginBottom: '0.5rem' }}>
                <Col span={12}>
                    <Input
                        prefix={<TbSearch style={{ color: token.colorTextQuaternary, marginRight: '0.375rem' }} />}
                        placeholder={`Filter Options...`}
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                    />
                </Col>
                <Col flex='auto' />
                <Col flex='none'>
                    <Button
                        aria-label='Close data sources'
                        icon={<TbX size='1rem' style={{ color: token.colorTextTertiary, display: 'block' }} />}
                        onClick={() => setOpen(false)}
                        size='small'
                    />
                </Col>
            </Row>
            <FlexContentRegion>
                <DataSourceList
                    view={view}
                    category={option}
                    options={options ?? []}
                    setOpen={setOpen}
                    loading={loading}
                />
            </FlexContentRegion>
        </FullHeightFlexColumn>
    );
};

export default Content;
